<template lang="pug">
.containers
  .logo-area
  .hrWhite
  .menu-cell(@click="select('SchoolList')")
    p.menu-label 施設一覧
  .menu-cell(@click="select('ManagerList')")
    p.menu-label 管理者一覧
  .menu-cell(@click="select('Password')")
    p.menu-label パスワード変更
  .menu-cell(@click="select('Maintenance')")
    p.menu-label メンテナンス
  .menu-cell(@click="select('Message')")
    p.menu-label 個別メッセージ
  .menu-cell(@click="logoutModal")
    p.menu-label ログアウト
  template(v-if="showLogout")
    gb-mask(:show="true")
      .gb-card-cancel.disable-card
        .cancel-box(@click="cancel")
          p.cancel-bottom ×
        h3(style="margin:auto;") ログアウトしますか？
        .logout
          gb-button.danger(@clicked="signOut" style="width:300px;") OK
</template>
<script>
import util from '@/api/util'
import LocalDataUtil from '@/util/LocalDataUtil.js'
import moment from 'moment'

import GbMask from '@/components/atoms/GbMask.vue'
import GbCard from '@/components/atoms/GbCard.vue'
import GbButton from '@/components/atoms/GbButton.vue'
export default {
  components: {
    GbButton,
    GbMask,
    GbCard
  },
  name: 'SideMenu',
  data () {
    return {
      showLogout: false
    }
  },
  methods: {
    select (key) {
      if (key === 'SchoolList') {
        this.$router.push({name: 'SchoolList'})
      }
      if (key === 'ManagerList') {
        this.$router.push({name: 'ManagerList'})
      }
      if (key === 'Password') {
        this.$router.push({name: 'ResetPassword'})
      }
      if (key === 'Maintenance') {
        this.$router.push({name: 'Maintenance'})
      }
      if (key === 'Message') {
        this.$router.push({name: 'Message'})
      }
    },
    async logoutModal () {
      const isMaintenance = (await util.checkMaintenance({type: 'admin'})).data.data.is_maintenance
      if (isMaintenance) {
        this.$swal.fire({
          html: `現在メンテナンス中です`
        }).then(() => {
          this.$router.push({ name: 'Maintenance' })
        })
      } else {
        this.showLogout = true
      }
    },
    cancel () {
      this.showLogout = false
    },
    backToLogIn () {
      const accessToken = LocalDataUtil.getJwtToken()
      if (accessToken) {
        const base64Url = accessToken.split('.')[1]
        const base64 = base64Url.replace('-', '+').replace('_', '/')
        const EXPIRE = JSON.parse(window.atob(base64)).exp
        if (EXPIRE + 10000 > moment().unix()) {
          return true
        } else {
          this.signOut()
          this.$router.push({ name: 'SignIn' })
        }
      } else {
        this.signOut()
        this.$router.push({ name: 'SignIn' })
      }
    },
    signOut () {
      util.createMethod('COG', 'signOut', null)
        .then(() => {
          localStorage.clear()
          location.href = '/signin'
        })
    }
  },
  created () {
    this.backToLogIn()
  }
}
</script>
<style lang="stylus" scoped>
@import '../../stylus/main.styl'
.containers
  width 9vw
  min-height 100%
  display flex
  flex-direction column
  justify-content flex-start
  align-items stretch
  background-color $color-secondary
  position fixed
.logo-area
  display flex
  justify-content center
  align-items center
  padding 36px
.logo
  width 120px
  height auto
.menu-cell
  height 40px
  font-weight 500
  padding 16px
  display flex
  flex-direction row
  align-items center
  &:hover
    background-color rgba(255, 255, 255, 0.2)
.menu-icon
  font-family 'Simple Line Icon'
  width 24px
  color #fff
.menu-label
  font-size 12px
  flex 1
  color #fff
.cancel-box
  width 50px
  height 50px
  border-bottom 1px solid #000
  border-left 1px solid #000
  display grid
  align-items center
.cancel-bottom
  font-size 30px
  text-align center
  font-weight 300
.logout
  margin 0 auto 50px
.gb-card-cancel
  background-color #fff
  border-radius 2px
  padding-top 0
  padding-right 0
  display flex
  align-items flex-end
.disable-card
  width 680px
  height 400px
  display flex
  flex-direction column
  justify-content space-between
</style>



// WEBPACK FOOTER //
// src/components/organisms/GbSideMenu.vue